import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { partial } from '../../../util/translation/translation';

const p = partial('NewsForm');

const UNITS = [
  ['days', 24 * 60 * 60],
  ['hours', 60 * 60],
  ['minutes', 60],
  ['seconds', 1],
];

// What's left until the date, in whole days, hours, minutes and seconds
const remaining = (date) => {
  let left = Math.max(Math.floor((new Date(date) - Date.now()) / 1000), 0);
  return UNITS.map(([unit, size]) => {
    const amount = Math.floor(left / size);
    left -= amount * size;
    return [unit, amount];
  });
};

// A count down in the app preview: days, hours, minutes and seconds to its
// date, then its end text (or nothing) once it's reached
const CountDownPreview = ({ date, label, endText }) => {
  const [, setTick] = useState(0);
  const time = new Date(date).getTime();
  const reached = time <= Date.now();

  useEffect(() => {
    if (!Number.isFinite(time) || reached) return undefined;
    const timer = setInterval(() => setTick((tick) => tick + 1), 1000);
    return () => clearInterval(timer);
  }, [time, reached]);

  if (!Number.isFinite(time) || (reached && !endText)) {
    return null;
  }
  return (
    <div className="app-preview-counter">
      {label ? <div className="app-preview-counter__label">{label}</div> : null}
      {reached ? (
        <div className="app-preview-counter__end">{endText}</div>
      ) : (
        <div className="app-preview-counter__units">
          {remaining(date).map(([unit, amount]) => (
            <div className="app-preview-counter__unit" key={unit}>
              <span className="app-preview-counter__value">
                {String(amount).padStart(2, '0')}
              </span>
              <span className="app-preview-counter__label">
                {p(`COUNT_DOWN_${unit}`)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

CountDownPreview.propTypes = {
  date: PropTypes.string,
  label: PropTypes.string,
  endText: PropTypes.string,
};

CountDownPreview.defaultProps = {
  date: '',
  label: '',
  endText: '',
};

export default CountDownPreview;
